import {Component, OnInit, Input} from 'ng-metadata/core';

/**
 * @title Slider with custom thumb label formatting.
 */
@Component({
  selector: 'prm-slider-field',
  templateUrl: 'components/search/fullView/ngrs/sliderField/slider-field.html'
})
export class PrmSliderField {
  public min="0";
  public max="90";


    constructor (){       
    }

    ngOnInit(){
      
    }  

    public getMin(){
      return 0;
    }

    public getMax(){
      return 90;
    }    
 
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/sliderField/sliderField.directive.ts